import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FSAlertOrderTableColumns, FSAlertOrderTableDataMap } from 'app/dashboard/post-dispatch/post-dispatch.constants';
import { OrderFrontEndStateEnum } from 'app/dashboard/post-dispatch/post-dispatch.interfaces';
import { PostDispatchService } from 'app/dashboard/post-dispatch/post-dispatch.service';
import { UiColors } from 'app/interfaces/ui.interfaces';
import { IconTypes } from 'app/shared/icon/icon.interfaces';
import { Order, CollapsibleTableTypeEnum, Paginate, PaginateEnum } from 'app/shared/shared.interfaces';
import { TableAction, SortEvent } from 'app/shared/table/table.interfaces';
import { Observable, Subscription, from } from 'rxjs';

@Component({
  selector: 'app-dispatch-alerts',
  templateUrl: './dispatch-alerts.component.html',
  styleUrls: ['./dispatch-alerts.component.scss']
})
export class DispatchAlertsComponent implements OnInit, OnDestroy {

  @Input() postDispatchTablePrimaryActions: TableAction[] = [];

  Icons = {
    Colors: UiColors,
    Types: IconTypes,
  };

  alertFirestoreTrips: Observable<Order[]>;
  alertAmount: number = 10;
  alertSubscription: Subscription;
  alertTotal: number;

  fsAlertOrderTableColumns = FSAlertOrderTableColumns;
  fsAlertOrderTableDataMap = FSAlertOrderTableDataMap;

  CollapsibleTableTypeEnum = CollapsibleTableTypeEnum;
  OrderFrontEndStateEnum = OrderFrontEndStateEnum;

  constructor(private postDispatchService: PostDispatchService) { }

  ngOnInit(): void {
    this.getData();
  }

  ngOnDestroy(): void {
    this.alertSubscription?.unsubscribe();
  }

  getData(): void {
    this.handleAlertTrips({ Amount: this.alertAmount, Direction: PaginateEnum.None });
    this.handlePostDispatchTotals();
  }

  handlePostDispatchTotals(): void {
    this.postDispatchService.getPostDispatchTotals(false).then((data) => {
      this.alertTotal = data.output.find((x) => x.State === OrderFrontEndStateEnum.Alert)?.Cnt;
    });
  }

  handleAlertTrips($event: Paginate): void {
    this.alertAmount = $event.Amount;
    this.alertSubscription?.unsubscribe();
    this.alertSubscription = this.postDispatchService
      .getFireStoreOrderSummaryStreamByState(this.alertAmount, $event.Direction, OrderFrontEndStateEnum.Alert, false)
      .subscribe((response) => {
        if (response[0]) {
          this.postDispatchService.setTripSnapshot(
            {
              First: response[0].payload.doc,
              Last: response[response.length - 1].payload.doc,
            },
            OrderFrontEndStateEnum.Alert
          );

          const data: Order[] = [];
          for (const item of response) {
            data.push(item.payload.doc.data());
          }
          this.alertFirestoreTrips = from([data]);
        } else {
          this.alertFirestoreTrips = from([]);
        }
      });
  }

  handleTripsSortChange($event: SortEvent): void {
    this.postDispatchService.orderOrderBy = $event;
    this.handleAlertTrips({ Amount: this.alertAmount, Direction: PaginateEnum.None });
  }
}
